import { render, staticRenderFns } from "./RelatedProjects.vue?vue&type=template&id=1393ddee&scoped=true&"
import script from "./RelatedProjects.vue?vue&type=script&lang=js&"
export * from "./RelatedProjects.vue?vue&type=script&lang=js&"
import style0 from "./RelatedProjects.vue?vue&type=style&index=0&id=1393ddee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1393ddee",
  null
  
)

export default component.exports